import { createBrowserRouter, Navigate } from 'react-router-dom';
import { PATHS } from './paths';
import AppShell from '@app/layout/AppShell';
import PanelLayout from '@app/layout/PanelLayout';
import FullScreenLayout from '@app/layout/FullScreenLayout';
import NotFoundPage from './NotFoundPage';
import StatusPage from '@features/status/StatusPage';
import RoutesPage from '@features/routes/RoutesPage';
import RouteDetailPage from '@features/routes/RouteDetailPage';
import RouteEditPage from '@features/routes/RouteEditPage';
import HoldingsPage from '@features/holdings/HoldingsPage';
import CatalogPage from '@features/catalog/CatalogPage';
import OrdersPage from '@features/orders/OrdersPage';
import OrderDetailPage from '@features/orders/OrderDetailPage';
import SupportPage from '@features/support/SupportPage';
import UpdatesPage from '@features/updates/UpdatesPage';
import TransfersPage from '@features/transfers/TransfersPage';
import ActivityPage from '@features/activity/ActivityPage';
import BasketPanel from '@features/basket/components/BasketPanel';
import SettingsPage from '@app/settings/SettingsPage';

export const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      {
        index: true,
        element: <Navigate to={PATHS.STATUS} replace />,
      },
      {
        element: <PanelLayout />,
        children: [
          { path: PATHS.STATUS, element: <StatusPage /> },
          { path: PATHS.ROUTES, element: <RoutesPage /> },
          { path: PATHS.ROUTES_DETAILS, element: <RouteDetailPage /> },
          { path: PATHS.ROUTES_EDIT, element: <RouteEditPage /> },
          { path: PATHS.HOLDINGS, element: <HoldingsPage /> },
          { path: PATHS.CATALOG, element: <CatalogPage /> },
          { path: PATHS.ORDERS, element: <OrdersPage /> },
          { path: PATHS.ORDERS_DETAIL, element: <OrderDetailPage /> },
          { path: PATHS.SUPPORT, element: <SupportPage /> },
          { path: PATHS.BASKET, element: <BasketPanel /> },
        ],
      },
      {
        element: <FullScreenLayout />,
        children: [
          { path: PATHS.UPDATES, element: <UpdatesPage /> },
          { path: PATHS.TRANSFERS, element: <TransfersPage /> },
          { path: PATHS.ACTIVITY, element: <ActivityPage /> },
          { path: PATHS.SETTINGS, element: <SettingsPage /> },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
